import DiscussionIcon from 'assets/icons/initiativeDiscussion'
import EventIcon from 'assets/icons/initiativeEvent'
import GroupIcon from 'assets/icons/initiativeGroup'
import PostIcon from 'assets/icons/initiativePost'
import ResourceIcon from 'assets/icons/initiativeResource'

export default [{
   type: 'blog',
   initiativeClass: 'post',
   icon: PostIcon
}, {
   type: 'discussions',
   initiativeClass: 'discussion',
   icon: DiscussionIcon
}, {
   type: 'events',
   initiativeClass: 'event',
   icon: EventIcon
}, {
   type: 'groups',
   initiativeClass: 'group',
   icon: GroupIcon
}, {
   type: 'groups',
   initiativeClass: 'project',
   icon: GroupIcon
}, {
   type: 'resources',
   initiativeClass: 'resource',
   icon: ResourceIcon
}]
